const XP = {
  LEVEL_XP: [
    0,
    300,
    450,
    600,
    800,
  ],

  TRAINING_XP: 180,
};

XP.getLevelFromXP = function (totalXP, potential) {
  let remaining = totalXP;
  let level = 1;
  for (let lvl = 1; lvl <= potential; lvl++) {
    const needed = XP.LEVEL_XP[lvl];
    if (!needed || remaining < needed) break;
    remaining -= needed;
    level++;
  }
  return Math.min(level, potential);
};

XP.getTotalXPForLevel = function (level) {
  return XP.LEVEL_XP.slice(1, level).reduce((a, b) => a + b, 0);
};

export default XP;
